import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: '#eef6ff' },
          100: { value: '#d9eaff' },
          200: { value: '#b7d6ff' },
          300: { value: '#8bb9ff' },
          400: { value: '#5d96fa' },
          500: { value: '#3a73ec' },
          600: { value: '#2a59c8' },
          700: { value: '#22459b' },
          800: { value: '#1e3879' },
          900: { value: '#16285a' },
        },
        ink: {
          50: { value: '#f7f8fb' },
          100: { value: '#eceef4' },
          200: { value: '#d6dae6' },
          300: { value: '#b3bbcc' },
          400: { value: '#7c869c' },
          500: { value: '#525c74' },
          600: { value: '#3b4358' },
          700: { value: '#2a3142' },
          800: { value: '#1c2230' },
          900: { value: '#11151f' },
        },
        lot: {
          disponible: { value: '#1e9e6a' },
          reservado: { value: '#e0a400' },
          vendido: { value: '#c2410c' },
          bloqueado: { value: '#6b7280' },
        },
      },
      fonts: {
        heading: { value: 'Inter, ui-sans-serif, system-ui, sans-serif' },
        body: { value: 'Inter, ui-sans-serif, system-ui, sans-serif' },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          canvas: { value: { base: '{colors.ink.50}', _dark: '{colors.ink.900}' } },
          surface: { value: { base: 'white', _dark: '{colors.ink.800}' } },
          subtle: { value: { base: '{colors.ink.100}', _dark: '{colors.ink.700}' } },
        },
        fg: {
          DEFAULT: { value: { base: '{colors.ink.900}', _dark: '{colors.ink.50}' } },
          muted: { value: { base: '{colors.ink.500}', _dark: '{colors.ink.300}' } },
          subtle: { value: { base: '{colors.ink.400}', _dark: '{colors.ink.400}' } },
        },
        border: {
          DEFAULT: { value: { base: '{colors.ink.200}', _dark: '{colors.ink.700}' } },
        },
      },
    },
  },
  globalCss: {
    'html, body, #root': {
      height: '100%',
      margin: 0,
      padding: 0,
      background: 'bg.canvas',
      color: 'fg',
      fontFeatureSettings: '"cv11", "ss01"',
    },
    body: {
      fontFamily: 'body',
    },
  },
});

export const system = createSystem(defaultConfig, config);
